import type { LogEntry, LogSink } from "@skaile/workspaces/types";

/**
 * OnLogBridgeSink — forwards every entry as a single formatted text line to
 * a legacy `onLog(line)` callback. Used as a back-compat bridge for callers
 * that historically received plain text lines from the runner.
 *
 * Format: `[level] [kind:subkind[:instance]] message [data-json] [— error.message]`
 */
export class OnLogBridgeSink implements LogSink {
  constructor(private readonly onLog: (line: string) => void) {}

  write(entry: LogEntry): void {
    const tag = entry.source.instance
      ? `${entry.source.kind}:${entry.source.subkind}:${entry.source.instance}`
      : `${entry.source.kind}:${entry.source.subkind}`;
    let line = `[${entry.level}] [${tag}] ${entry.message}`;
    if (entry.data && Object.keys(entry.data).length > 0) {
      line += ` ${JSON.stringify(entry.data)}`;
    }
    if (entry.error?.message) {
      line += ` — ${entry.error.message}`;
    }
    this.onLog(line);
  }

  writeBatch(entries: LogEntry[]): void {
    for (const e of entries) this.write(e);
  }

  close(): void {
    /* no-op */
  }
}
